export const errorHandling = {
    methods : {
        errorHandler(exception) {
            if (exception) {
                if (exception.error || exception.message) {
                    this.$root.errorMessage = exception.error || exception.message;
                }

                if (exception?.response?.data?.error || exception?.response?.data?.message) {
                    this.$root.errorMessage = exception?.response?.data?.error || exception?.response?.data?.message;
                }

                if (typeof exception === 'string') {
                    this.$root.errorMessage = exception;
                }
            }
        }
    }
};
